const STATUS_STYLES: Record<string, { bg: string; color: string; icon: string }> = {
  Open: { bg: "#fdecea", color: "#c0392b", icon: "uil-exclamation-circle" },
  "In-Review": { bg: "#e8f1fd", color: "#1f6fd1", icon: "uil-history" },
  Pending: { bg: "#fff8e1", color: "#b7860b", icon: "uil-clock" },
  Closed: { bg: "#e8f8ee", color: "#1e8e4e", icon: "uil-check-circle" },
};

const StatusBadge = ({
  status,
  className = "",
}: {
  status?: string;
  className?: string;
}) => {
  const style = STATUS_STYLES[status || ""] || {
    bg: "#f1f1f1",
    color: "#555",
    icon: "uil-info-circle",
  };

  return (
    <span
      className={`d-inline-flex align-items-center gap-1 fw-semibold ${className}`}
      style={{
        backgroundColor: style.bg,
        color: style.color,
        padding: "5px 12px",
        borderRadius: "999px",
        fontSize: "0.8rem",
        lineHeight: 1.4,
        whiteSpace: "nowrap",
      }}
    >
      <i className={`uil ${style.icon}`} style={{ fontSize: "0.9rem" }}></i>
      {status || "Unknown"}
    </span>
  );
};

export default StatusBadge;
